export default __webpack_public_path__ + "static/media/timer_bottom.b6c728ae.svg";